<div class="number number-input" [attr.data-post]="dataPost || null" [attr.data-pre]="dataPre || null">
  <button type="button" class="number-remove" (click)="countChange(numberInput! - 1)"></button>
  <input type="text" (ngModelChange)="countChange($event)" [ngModel]="numberInput" />
  <button type="button" class="number-add" (click)="countChange(numberInput! + 1)"></button>
</div>